class VariantColors extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    this._getContent();
  }
  async _getContent() {
    const res = await fetch(this.dataset.url);
    const htmlText = await res.text();
    const Parser = new DOMParser();
    const newHTML = Parser.parseFromString(htmlText, 'text/html');
    this._injectContent(newHTML);
  }
  _injectContent(html) {
    const newWrapper = html.querySelector(".variant-colors");
    this.innerHTML = newWrapper.innerHTML;
  }
}

customElements.define('variant-colors', VariantColors);